// extracted by mini-css-extract-plugin
export var container = "_r5-0";
export var table = "_r5-2";
export var tableWrapper = "_r5-1";